module.exports = __webpack_public_path__ + "img/phoenix_kedel_1.c99ba728.png";